module.exports = __webpack_public_path__ + "static/media/ImporterFeature1.fd45a5a6.svg";